import {configureStore} from '@reduxjs/toolkit';
import basket from '../model/basket';
import category from '../model/category';
import productDetail from '../model/productdetail';
import productList from '../model/productlist';

export const store = configureStore({
  reducer: {
    basket: basket,
    category: category,
    productDetail: productDetail,
    productList: productList,
  },
});
